"use client";

import { useState, ReactNode, Dispatch, SetStateAction } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TermChip from "../TermChip";

interface TextFieldWithChipsProps {
  className?: string;
  encodedFilterParams: string;
  label?: string | ReactNode;
  name: string;
  placeholder: string;
  setTerms: Dispatch<SetStateAction<Record<string, string>>>;
  showAddButton?: boolean;
  showCountBadge?: boolean;
  terms: Record<string, string>;
}

export default function TextFieldWithChips({
  terms,
  setTerms,
  encodedFilterParams,
  name,
  placeholder,
  label,
  showCountBadge = false,
  showAddButton = true,
  className,
}: TextFieldWithChipsProps) {
  const [text, setText] = useState("");

  const addTerm = () => {
    if (text.trim() === "") return;
    setTerms({ ...terms, [text.toLowerCase()]: text });
    setText("");
  };

  return (
    <div className={className}>
      <TextField
        value={text}
        onChange={(event) => setText(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            addTerm();
          }
        }}
        slotProps={{
          input: {
            endAdornment: showAddButton ? (
              <InputAdornment position="end">
                <IconButton onClick={addTerm} edge="end">
                  <AddIcon />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
        label={label}
        placeholder={placeholder}
        fullWidth
      />
      {/* This is for if a user tries a search with a term in the input but unsubmitted */}
      {text && <input type="hidden" name={name} value={text} />}
      <div className="flex flex-wrap gap-2 mt-2">
        {Object.entries(terms).map(([key, value]) => (
          <TermChip
            name={name}
            term={value}
            encodedFilterParams={encodedFilterParams}
            showCountBadge={showCountBadge}
            key={key}
            onDelete={() => {
              const newTerms = { ...terms };
              delete newTerms[value.toLowerCase()];
              setTerms(newTerms);
            }}
          />
        ))}
      </div>
    </div>
  );
}
